import mitt from 'mitt'

const emitter = mitt()

export default {
  $on: (type: any, handler: any) =>  emitter.on(type, handler),
  $off: (type: any, handler: any) => emitter.off(type, handler),
  $emit: (type: any, parameters: any = undefined) => emitter.emit(type, parameters)
}